// project hash key
// e921d896b24ee51ad95dc303a034758da1187532b0a44189bd99aa333255781b

export const setBackGroundLineUp = (rankName) => {
  let result = {
    color: '',
    background: '',
    bgWinRate: '',
  };
  switch (rankName) {
    case 'A':
      result = {
        color: 'my-color-dark-red',
        background: 'my-bg-pink',
        bgWinRate: 'my-bg-winRate-red',
      };
      break;
    case 'B':
      result = {
        color: 'my-color-blue-600',
        background: 'my-bg-blue-600',
        bgWinRate: 'my-bg-winRate-green',
      };
      break;
    case 'C':
      result = {
        color: 'my-dark-green',
        background: 'my-bg-green-light',
        bgWinRate: 'my-bg-winRate-orange',
      };
      break;
    case 'D':
      result = {
        color: 'my-cerise-pink',
        background: 'my-bg-yellow-light',
        bgWinRate: 'my-bg-winRate-blue',
      };
      break;
    case 'E':
      result = {
        color: 'my-water-blue',
        background: 'my-bg-black-200',
        bgWinRate: 'my-bg-winRate-black',
      };
      break;
    default:
      break;
  }
  return result;
};
